import { css, StyleDeclaration } from 'aphrodite';
import * as React from 'react';
import {
	Dropdown,
	DropdownContent,
	DropdownEllipsisTrigger,
	DropdownItem,
} from '../../../../../components-v2/Dropdown';
import { bs } from '../../../../../styles/styles';
import { styleSheet } from './styles';

interface Props {
	title: string;
	blurb?: string;
	styles?: StyleDeclaration[];
	// Dropdown functionality props
	onRemoveQuestion?: () => void;
	isOptionField?: boolean;
	hasTagPrefix?: boolean;
	tagPrefix?: React.ReactNode;
	onCreateTag?: () => void;
	onEditTag?: () => void;
	// Custom field functionality props
	hasCustomField?: boolean;
	hasExistingCustomField?: boolean;
	customField?: React.ReactNode;
	onCreateCustomField?: () => void;
	onEditCustomField?: () => void;
	dropdownStyles?: StyleDeclaration[];
}

export const SectionTitle = ({
	title,
	blurb,
	styles = [],
	onRemoveQuestion,
	isOptionField = false,
	hasTagPrefix = false,
	tagPrefix = null,
	onCreateTag,
	onEditTag,
	hasCustomField = false,
	hasExistingCustomField = false,
	customField = null,
	onCreateCustomField,
	onEditCustomField,
	dropdownStyles = [],
}: Props) => {
	// Determine if dropdown should be shown
	const shouldShowDropdown =
		onRemoveQuestion ||
		(isOptionField && (onCreateTag || onEditTag)) ||
		(hasCustomField && (onCreateCustomField || onEditCustomField)) ||
		(!hasCustomField && onCreateCustomField);

	return (
		<header className={css(bs.flex, bs.flexCol, styleSheet.header, ...styles)}>
			<div className={css(styleSheet.headerContent)}>
				<div className={css(bs.fullWidth)}>
					<h3 className={css(styleSheet.sectionTitle)}>{title}</h3>
					{blurb ? <p className={css(styleSheet.blurb)}>{blurb}</p> : null}
				</div>
				<div className={css(bs.flex, bs.flexCol)}>
					<div className={css(bs.flex, bs.gap3, bs.justifyEnd)}>
						{tagPrefix}
						{customField}
						{shouldShowDropdown && (
							<Dropdown>
								<DropdownEllipsisTrigger styles={dropdownStyles.filter(Boolean)} />
								<DropdownContent styles={[styleSheet.dropdownContent]}>
									{/* Remove Question */}

									{/* Tag Management - only show for option fields */}
									{isOptionField && (
										<>
											{hasTagPrefix ? (
												<>
													{onEditTag && (
														<DropdownItem onClick={onEditTag} styles={[styleSheet.dropdownItem]}>
															Edit Tag
														</DropdownItem>
													)}
												</>
											) : (
												onCreateTag && (
													<DropdownItem onClick={onCreateTag} styles={[styleSheet.dropdownItem]}>
														Create Tags from Answers
													</DropdownItem>
												)
											)}
										</>
									)}

									{/* Custom Field Management */}
									{hasCustomField && onCreateCustomField && !hasExistingCustomField && (
										<DropdownItem onClick={onCreateCustomField} styles={[styleSheet.dropdownItem]}>
											Link Answer to Custom field
										</DropdownItem>
									)}
									{hasCustomField && onEditCustomField && hasExistingCustomField && (
										<DropdownItem onClick={onEditCustomField} styles={[styleSheet.dropdownItem]}>
											Edit Custom Field
										</DropdownItem>
									)}
									{onRemoveQuestion && (
										<DropdownItem
											onClick={onRemoveQuestion}
											styles={[styleSheet.removeQuestionButton, styleSheet.dropdownItem]}
										>
											Delete Question
										</DropdownItem>
									)}
								</DropdownContent>
							</Dropdown>
						)}
					</div>
				</div>
			</div>
		</header>
	);
};
